import React, { useCallback, useEffect, useRef } from "react";
import { Carousel } from "react-responsive-carousel";
import noPhoto from "../../images/icons/nophoto.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PropTypes from "prop-types";

const PhotoCarousel = ({ listing, photoRenderer, carouselProps }) => {
  const hasFullSizePhotos = Boolean(listing?.ListingPhotosFullsize?.length);
  const renderPhoto = useCallback((photo) => {
    return (
      <div key={photo}>
        <img src={photo} alt={photo} />
      </div>
    );
  }, []);
  const ref = useRef(null);
  const pictureGallery = !hasFullSizePhotos ? (
    <img src={noPhoto} alt="nophoto" />
  ) : (
    listing.ListingPhotosFullsize.map(photoRenderer || renderPhoto)
  );

  useEffect(() => {
    //hacky to autofocus the carousel when this component is rendered inside a modal
    ref.current?.forceFocus?.();
  }, []);

  return (
    <Carousel
      showIndicators={false}
      showStatus={false}
      infiniteLoop={false}
      dynamicHeight={true}
      showThumbs={false}
      useKeyboardArrows
      autoFocus
      ref={ref}
      {...carouselProps}
    >
      {pictureGallery}
    </Carousel>
  );
};
export default PhotoCarousel;

PhotoCarousel.propTypes = {
  listing: PropTypes.object.isRequired,
  photoRenderer: PropTypes.func,
  carouselProps: PropTypes.shape({...Carousel.defaultProps}),
};
